import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageAPL2 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Grace Geyoro Transfer Record",
            author: "footballgirl",
              date: "January, 2026",
            image: "images/apl/2a.jpg",
            content: `
<h2>A Historic Deal That Shook Women’s Football</h2>

<p>
In early September 2025, French international midfielder Grace Geyoro stunned the women’s football world by leaving Paris Saint-Germain Féminine to join London City Lionesses in one of the largest transfer fees ever paid for a female player. While figures were initially disputed, multiple reports at the time put the fee at around £1.4 million (≈ €1.6 million / $1.9 million) — potentially setting a new women’s transfer record.
</p>

<p>
The deal was heralded as a watershed moment for the sport, illustrating how financial investment in women’s football is accelerating. It also underlined London City’s ambition after promotion to the Women’s Super League and heavy summer recruitment backed by owner Michele Kang.
</p>

<h2>Why Geyoro Took the Leap</h2>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>

<p>
At 28, Geyoro arrived at London City with a decorated career behind her: over 100 caps for the France women's national football team, domestic and European success with PSG, and a reputation as one of Europe’s most complete midfielders. The move offered her a new challenge in arguably the most competitive domestic league in women’s football — the WSL — and the chance to help establish a young, ambitious club on the English stage.
</p>

<p>
Geyoro signed a long-term contract and was expected to anchor London City’s midfield with her leadership and technical quality, bringing both experience and international pedigree to a squad that included other high-profile signings.
</p>

<h2>On the Pitch: Mixed Fortunes in Early 2025-26</h2>

<p>
Nearly six months on, Geyoro has been a regular presence in the London City squad, playing through a challenging first half of the WSL season. The club’s league campaign has been mixed: while showing flashes of promise against established sides, consistency has been difficult to find. As of early 2026, London City sat mid-table, reflecting the adjustment period common for newly promoted teams.
</p>

<p>
In domestic cups, Geyoro has featured regularly, including an intense FA Cup tie against Tottenham Hotspur, where she started and helped drive the midfield before being substituted late in the match.
</p>

<h2>Club Changes and Evolving Ambitions</h2>

<p>
The season also brought managerial change: after a slow start, London City Lionesses made a mid-season coaching switch, replacing Jocelyn Prêcheur with Eder Maestre in January 2026. Management cited the need for tactical evolution as the club aims to stabilize its top-flight status and leverage its significant investment.
</p>

<p>
Geyoro’s role under the new coach remains central, with expectations that her influence will grow as the squad adapts to tactical shifts. Observers have noted her leadership in training and transition play, even if goals and assists have not yet matched the hype of her transfer valuation.
</p>

<h2>What the Transfer Means for the Women’s Game</h2>

<p>
Whether the fee ranks as an official “world record” remains murky — London City’s chief initially denied it was the highest ever — but there’s no doubt the move was among the most expensive in the women’s game at the time.
</p>

<p>
Beyond the numbers, Geyoro’s transfer highlighted a broader shift: clubs outside traditional powerhouses now have the financial muscle to compete for elite talent, reshaping competitive balance in the WSL and beyond. It also showed that experienced internationals see value in joining ambitious projects rather than only established giants.
</p>

<h2>Looking Ahead</h2>

<p>
As the 2025-26 season progresses, all eyes remain on how Geyoro’s presence will shape London City’s fortunes. With a demanding second half of the season ahead — both domestically and potentially in cup competitions — her leadership and experience may prove decisive.
</p>

<p>
For the sport at large, the transfer stands as a symbol of growth — but also a reminder that investment must be matched with long-term strategy if new challengers are to thrive.
</p>

<h1>格蕾丝·盖约罗创女子转会纪录加盟伦敦城雌狮</h1>

<h2>震撼女子足坛的历史性交易</h2>

<p>
2025年9月初，法国国脚中场格蕾丝·盖约罗离开巴黎圣日耳曼女足，加盟伦敦城雌狮，这一转会震惊了整个女子足球界。这笔交易成为女子足球历史上金额最高的转会之一。尽管最初外界对具体金额存在争议，多家媒体报道称转会费约为140万英镑（约160万欧元 / 190万美元），有可能创下新的女子足球转会纪录。
</p>

<p>
这笔交易被视为女子足球发展的重要里程碑，体现了该领域日益增长的商业投入与资本信心。同时，这也凸显了伦敦城在升入女子超级联赛后展现出的雄心壮志，以及在俱乐部老板米歇尔·康支持下进行的大规模夏季引援。
</p>

<h2>为何选择新的挑战</h2>

<p>
28岁的盖约罗在加盟伦敦城时，已拥有辉煌的职业履历：代表法国国家女子足球队出场超过100次，在巴黎圣日耳曼取得国内与欧洲赛场的成功，并被公认为欧洲最全面的中场球员之一。此次转会为她提供了新的挑战——加盟被广泛认为竞争最激烈的女子国内联赛之一——英格兰女子超级联赛（WSL），并帮助一支年轻而充满抱负的俱乐部在英格兰赛场站稳脚跟。
</p>

<p>
盖约罗签署了一份长期合同，被寄予厚望成为球队中场核心。她的领导能力与技术实力，将为阵容带来国际经验和稳定性，同时也为球队注入更高层次的竞争力。
</p>

<h2>赛场表现：2025-26赛季初期的起伏</h2>

<p>
转会近六个月后，盖约罗已成为伦敦城阵中的常规主力，在充满挑战的赛季上半程中持续出场。球队在联赛中的表现起伏不定：虽在对阵传统强队时展现出潜力，但稳定性仍有待提高。截至2026年初，伦敦城排名联赛中游，这也反映了升班马通常需要经历的适应过程。
</p>

<p>
在国内杯赛中，盖约罗同样频繁出场，包括一场与托特纳姆热刺的足总杯激烈较量，她首发登场并在中场发挥关键作用，直至比赛后段被换下。
</p>

<h2>俱乐部变革与发展方向</h2>

<p>
赛季过程中，俱乐部也经历了教练更替。由于赛季初表现不理想，伦敦城在2026年1月进行换帅，由埃德尔·马埃斯特雷接替若瑟兰·普雷舍尔。管理层表示，此举旨在推动战术升级，确保球队在顶级联赛站稳脚跟，并最大化俱乐部的长期投资成果。
</p>

<p>
在新任主教练麾下，盖约罗依然是球队核心人物。随着战术体系逐步调整，外界普遍认为她的影响力将进一步提升。尽管进球与助攻数据尚未完全匹配其转会身价所带来的期待，但她在训练中的领导作用以及攻防转换中的贡献已受到广泛认可。
</p>

<h2>对女子足球的深远意义</h2>

<p>
这笔转会是否正式成为“世界纪录”仍存在争议——伦敦城方面曾否认这是史上最高转会费——但毫无疑问，这是一笔当时女子足球领域最昂贵的交易之一。
</p>

<p>
更重要的是，这次转会标志着女子足球格局的变化：传统豪门之外的俱乐部如今也具备吸引顶级球员的财力与雄心，从而重塑英格兰女子超级联赛乃至欧洲赛场的竞争版图。同时，这也表明，经验丰富的国际球员愿意投身具有远景规划的新兴项目，而不仅仅选择传统强队。
</p>

<h2>展望未来</h2>

<p>
随着2025-26赛季的深入，外界持续关注盖约罗如何进一步影响伦敦城的整体表现。赛季下半程任务艰巨，无论是在联赛还是潜在的杯赛征程中，她的经验与领导能力都可能成为决定性因素。
</p>

<p>
从更宏观的角度看，这笔转会象征着女子足球的持续增长与资本信心。但它也提醒人们：投资必须与长期战略相结合，只有这样，新兴俱乐部才能真正实现可持续发展。
</p>`,
            tags: ["france", "london city", "paris saint-germain", "geyoro", "Transfers"],
            readingTime: "7 min read",
            navIndices: { prev: 'apl-1', next: 'apl-3' }
        });
    }

    init() {
        console.log('ArticlePageAPL2 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to APL
            `;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'apl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_apl.png';
            leagueLogo.alt = 'APL';
        }
    }
}